var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var c = "comm";
var n = "rule";
var t = "decl";
var s = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var v = "@document";
var h = "@namespace";
var p = "@keyframes";
var b = "@font-face";
var w = "@counter-style";
var $ = "@font-feature-values";
var k = Math.abs;
var d = String.fromCharCode;
var g = Object.assign;

function m(e, r) {
  return (((r << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3);
}

function x(e) {
  return e.trim();
}

function y(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}

function j(e, r, a) {
  return e.replace(r, a);
}

function C(e, r) {
  return e.indexOf(r);
}

function z(e, r) {
  return e.charCodeAt(r) | 0;
}

function A(e, r, a) {
  return e.slice(r, a);
}

function O(e) {
  return e.length;
}

function M(e) {
  return e.length;
}

function S(e, r) {
  return r.push(e), e;
}

function q(e, r) {
  return e.map(r).join("");
}

var B = 1;
var D = 1;
var E = 0;
var F = 0;
var G = 0;
var H = "";

function I(e, r, a, c, n, t, s) {
  return {
    value: e,
    root: r,
    parent: a,
    type: c,
    props: n,
    children: t,
    line: B,
    column: D,
    length: s,
    return: ""
  };
}

function J(e, r) {
  return g(I("", null, null, "", null, null, 0), e, {
    length: -e.length
  }, r);
}

function K() {
  return G;
}

function L() {
  G = F > 0 ? z(H, --F) : 0;
  if (D--, G === 10) D = 1, B--;
  return G;
}

function N() {
  G = F < E ? z(H, F++) : 0;
  if (D++, G === 10) D = 1, B++;
  return G;
}

function P() {
  return z(H, F);
}

function Q() {
  return F;
}

function R(e, r) {
  return A(H, e, r);
}

function T(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;

    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;

    case 58:
      return 3;

    case 34:
    case 39:
    case 40:
    case 91:
      return 2;

    case 41:
    case 93:
      return 1;
  }

  return 0;
}

function U(e) {
  return B = D = 1, E = O(H = e), F = 0, [];
}

function V(e) {
  return H = "", e;
}

function W(e) {
  return x(R(F - 1, ee(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}

function X(e) {
  return V(Z(U(e)));
}

function Y(e) {
  while (G = P()) if (G < 33) N();else break;

  return T(e) > 2 || T(G) > 3 ? "" : " ";
}

function Z(e) {
  while (N()) switch (T(G)) {
    case 0:
      S(ae(F - 1), e);
      break;

    case 2:
      S(W(G), e);
      break;

    default:
      S(d(G), e);
  }

  return e;
}

function _(e, r) {
  while (--r && N()) if (G < 48 || G > 102 || G > 57 && G < 65 || G > 70 && G < 97) break;

  return R(e, Q() + (r < 6 && P() == 32 && N() == 32));
}

function ee(e) {
  while (N()) switch (G) {
    case e:
      return F;

    case 34:
    case 39:
      if (e !== 34 && e !== 39) ee(G);
      break;

    case 40:
      if (e === 41) ee(e);
      break;

    case 92:
      N();
      break;
  }

  return F;
}

function re(e, r) {
  while (N()) if (e + G === 47 + 10) break;else if (e + G === 42 + 42 && P() === 47) break;

  return "/*" + R(r, F - 1) + "*" + d(e === 47 ? e : N());
}

function ae(e) {
  while (!T(P())) N();

  return R(e, F);
}

function ce(e) {
  return V(ne("", null, null, null, [""], e = U(e), 0, [0], e));
}

function ne(e, r, a, c, n, t, s, u, i) {
  var f = 0;
  var o = 0;
  var l = s;
  var v = 0;
  var h = 0;
  var p = 0;
  var b = 1;
  var w = 1;
  var $ = 1;
  var k = 0;
  var g = "";
  var m = n;
  var x = t;
  var y = c;
  var z = g;

  while (w) switch (p = k, k = N()) {
    case 40:
      if (p != 108 && z.charCodeAt(l - 1) == 58) {
        if (C(z += j(W(k), "&", "&\f"), "&\f") != -1) $ = -1;
        break;
      }

    case 34:
    case 39:
    case 91:
      z += W(k);
      break;

    case 9:
    case 10:
    case 13:
    case 32:
      z += Y(p);
      break;

    case 92:
      z += _(Q() - 1, 7);
      continue;

    case 47:
      switch (P()) {
        case 42:
        case 47:
          S(se(re(N(), Q()), r, a), i);
          break;

        default:
          z += "/";
      }

      break;

    case 123 * b:
      u[f++] = O(z) * $;

    case 125 * b:
    case 59:
    case 0:
      switch (k) {
        case 0:
        case 125:
          w = 0;

        case 59 + o:
          if (h > 0 && O(z) - l) S(h > 32 ? ue(z + ";", c, a, l - 1) : ue(j(z, " ", "") + ";", c, a, l - 2), i);
          break;

        case 59:
          z += ";";

        default:
          S(y = te(z, r, a, f, o, n, u, g, m = [], x = [], l), t);
          if (k === 123) if (o === 0) ne(z, r, y, y, m, t, l, u, x);else switch (v) {
            case 100:
            case 109:
            case 115:
              ne(e, y, y, c && S(te(e, y, y, 0, 0, n, u, g, n, m = [], l), x), n, x, l, u, c ? m : x);
              break;

            default:
              ne(z, y, y, y, [""], x, 0, u, x);
          }
      }

      f = o = h = 0, b = $ = 1, g = z = "", l = s;
      break;

    case 58:
      l = 1 + O(z), h = p;

    default:
      if (b < 1) if (k == 123) --b;else if (k == 125 && b++ == 0 && L() == 125) continue;

      switch (z += d(k), k * b) {
        case 38:
          $ = o > 0 ? 1 : (z += "\f", -1);
          break;

        case 44:
          u[f++] = (O(z) - 1) * $, $ = 1;
          break;

        case 64:
          if (P() === 45) z += W(N());
          v = P(), o = l = O(g = z += ae(Q())), k++;
          break;

        case 45:
          if (p === 45 && O(z) == 2) b = 0;
      }

  }

  return t;
}

function te(e, r, a, c, t, s, u, i, f, o, l) {
  var v = t - 1;
  var h = t === 0 ? s : [""];
  var p = M(h);

  for (var b = 0, w = 0, $ = 0; b < c; ++b) for (var d = 0, g = A(e, v + 1, v = k(w = u[b])), m = e; d < p; ++d) if (m = x(w > 0 ? h[d] + " " + g : j(g, /&\f/g, h[d]))) f[$++] = m;

  return I(e, r, a, t === 0 ? n : i, f, o, l);
}

function se(e, r, a) {
  return I(e, r, a, c, d(K()), A(e, 2, -2), 0);
}

function ue(e, r, a, c) {
  return I(e, r, a, t, A(e, 0, c), A(e, c + 1, -1), c);
}

function ie(c, n) {
  switch (m(c, n)) {
    case 5103:
      return a + "print-" + c + c;

    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return a + c + c;

    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return a + c + r + c + e + c + c;

    case 6828:
    case 4268:
      return a + c + e + c + c;

    case 6165:
      return a + c + e + "flex-" + c + c;

    case 5187:
      return a + c + j(c, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + c;

    case 5443:
      return a + c + e + "flex-item-" + j(c, /flex-|-self/, "") + c;

    case 4675:
      return a + c + e + "flex-line-pack" + j(c, /align-content|flex-|-self/, "") + c;

    case 5548:
      return a + c + e + j(c, "shrink", "negative") + c;

    case 5292:
      return a + c + e + j(c, "basis", "preferred-size") + c;

    case 6060:
      return a + "box-" + j(c, "-grow", "") + a + c + e + j(c, "grow", "positive") + c;

    case 4554:
      return a + j(c, /([^-])(transform)/g, "$1" + a + "$2") + c;

    case 6187:
      return j(j(j(c, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), c, "") + c;

    case 5495:
    case 3959:
      return j(c, /(image-set\([^]*)/, a + "$1" + "$`$1");

    case 4968:
      return j(j(c, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + a + c + c;

    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return j(c, /(.+)-inline(.+)/, a + "$1$2") + c;

    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (O(c) - 1 - n > 6) switch (z(c, n + 1)) {
        case 109:
          if (z(c, n + 4) !== 45) break;

        case 102:
          return j(c, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (z(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;

        case 115:
          return ~C(c, "stretch") ? ie(j(c, "stretch", "fill-available"), n) + c : c;
      }
      break;

    case 4949:
      if (z(c, n + 1) !== 115) break;

    case 6444:
      switch (z(c, O(c) - 3 - (~C(c, "!important") && 10))) {
        case 107:
          return j(c, ":", ":" + a) + c;

        case 101:
          return j(c, /(.+:)([^;!]+)(;|!.+)?/, "$1" + a + (z(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + c;
      }

      break;

    case 5936:
      switch (z(c, n + 11)) {
        case 114:
          return a + c + e + j(c, /[svh]\w+-[tblr]{2}/, "tb") + c;

        case 108:
          return a + c + e + j(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;

        case 45:
          return a + c + e + j(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
      }

      return a + c + e + c + c;
  }

  return c;
}

function fe(e, r) {
  var a = "";
  var c = M(e);

  for (var n = 0; n < c; n++) a += r(e[n], n, e, r) || "";

  return a;
}

function oe(e, r, a, s) {
  switch (e.type) {
    case i:
    case t:
      return e.return = e.return || e.value;

    case c:
      return "";

    case p:
      return e.return = e.value + "{" + fe(e.children, s) + "}";

    case n:
      e.value = e.props.join(",");
  }

  return O(a = fe(e.children, s)) ? e.return = e.value + "{" + a + "}" : "";
}

function le(e) {
  var r = M(e);
  return function (a, c, n, t) {
    var s = "";

    for (var u = 0; u < r; u++) s += e[u](a, c, n, t) || "";

    return s;
  };
}

function ve(e) {
  return function (r) {
    if (!r.root) if (r = r.return) e(r);
  };
}

function he(c, s, u, i) {
  if (c.length > -1) if (!c.return) switch (c.type) {
    case t:
      c.return = ie(c.value, c.length);
      break;

    case p:
      return fe([J(c, {
        value: j(c.value, "@", "@" + a)
      })], i);

    case n:
      if (c.length) return q(c.props, function (n) {
        switch (y(n, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return fe([J(c, {
              props: [j(n, /:(read-\w+)/, ":" + r + "$1")]
            })], i);

          case "::placeholder":
            return fe([J(c, {
              props: [j(n, /:(plac\w+)/, ":" + a + "input-$1")]
            }), J(c, {
              props: [j(n, /:(plac\w+)/, ":" + r + "$1")]
            }), J(c, {
              props: [j(n, /:(plac\w+)/, e + "input-$1")]
            })], i);
        }

        return "";
      });
  }
}

function pe(e) {
  switch (e.type) {
    case n:
      e.props = e.props.map(function (r) {
        return q(X(r), function (r, a, c) {
          switch (z(r, 0)) {
            case 12:
              return A(r, 1, O(r));

            case 0:
            case 40:
            case 43:
            case 62:
            case 126:
              return r;

            case 58:
              if (c[++a] === "global") c[a] = "", c[++a] = "\f" + A(c[a], a = 1, -1);

            case 32:
              return a === 1 ? "" : r;

            default:
              switch (a) {
                case 0:
                  e = r;
                  return M(c) > 1 ? "" : r;

                case a = M(c) - 1:
                case 2:
                  return a === 2 ? r + e + e : r + e;

                default:
                  return r;
              }

          }
        });
      });
  }
}

export { f as CHARSET, c as COMMENT, w as COUNTER_STYLE, t as DECLARATION, v as DOCUMENT, b as FONT_FACE, $ as FONT_FEATURE_VALUES, i as IMPORT, p as KEYFRAMES, u as MEDIA, r as MOZ, e as MS, h as NAMESPACE, s as PAGE, n as RULESET, l as SUPPORTS, o as VIEWPORT, a as WEBKIT, k as abs, U as alloc, S as append, g as assign, Q as caret, K as char, G as character, H as characters, z as charat, D as column, q as combine, se as comment, re as commenter, ce as compile, J as copy, V as dealloc, ue as declaration, W as delimit, ee as delimiter, _ as escaping, d as from, m as hash, ae as identifier, C as indexof, E as length, B as line, y as match, le as middleware, pe as namespace, N as next, I as node, ne as parse, P as peek, F as position, ie as prefix, he as prefixer, L as prev, j as replace, te as ruleset, ve as rulesheet, fe as serialize, M as sizeof, R as slice, oe as stringify, O as strlen, A as substr, T as token, X as tokenize, Z as tokenizer, x as trim, Y as whitespace };